import BookShelf from 'components/modular/shelves/book-shelf'
import React from 'react'
import LazyLoad from 'react-lazyload'
import { useHistory } from 'react-router-dom'
import { SHOW_EVENT_SHELF, SHOW_OLYMPICS_SHELF } from 'routes/paths'
import {
  OLYMPICS_SHELF_SUBTITLE,
  OLYMPICS_SHELF_TITLE
} from './OlympicsShelf.constants'
import { useOlympicsShelf } from './OlympicsShelf.hooks'
import type { OlympicsShelfProps } from './OlympicsShelf.types'

const OlympicsShelf: React.FC<OlympicsShelfProps> = ({
  isStudentView = false,
  degree
}) => {
  const history = useHistory()
  const { shelves, loading, isEnabled, onClickBook } = useOlympicsShelf(
    isStudentView,
    degree
  )

  if (!isEnabled || (!loading && !shelves.length)) {
    return null
  }

  if (loading) {
    return (
      <BookShelf
        loading
        title={OLYMPICS_SHELF_TITLE}
        subtitle={OLYMPICS_SHELF_SUBTITLE}
        size="large"
        coversList={[]}
        onClickCover={onClickBook}
        onClickBtnGetMore={() => history.push(SHOW_OLYMPICS_SHELF)}
        isSeeAllButtonVisible
        showInfo
      />
    )
  }

  return (
    <>
      {shelves.map(({ shelf, books }) => (
        <BookShelf
          key={shelf.id}
          loading={false}
          title={shelf.name ?? OLYMPICS_SHELF_TITLE}
          subtitle={shelf.subtitle ?? undefined}
          size="large"
          coversList={books}
          onClickCover={onClickBook}
          onClickBtnGetMore={() => history.push(SHOW_EVENT_SHELF(shelf.id))}
          isSeeAllButtonVisible
          showInfo
        />
      ))}
    </>
  )
}

const OlympicsShelfWrapper: React.FC<OlympicsShelfProps> = props => {
  return (
    <LazyLoad once height={400} offset={200} resize>
      <OlympicsShelf {...props} />
    </LazyLoad>
  )
}

export default OlympicsShelfWrapper
